import { AxiosAdapter, AuthAdapter } from '@adapters';
import { SignOutUseCase } from '@core/useCases';
import { useCommonStore, useUserStore } from '@stores';

export const useSignOut = () => {
  const axiosAdapter = new AxiosAdapter();
  const authAdapter = new AuthAdapter(axiosAdapter);
  const signOutUseCase = new SignOutUseCase(authAdapter);
  const commonStore = useCommonStore();
  const userStore = useUserStore();
  const handleSignOut = async () => {
    commonStore.clearAccessToken();
    userStore.resetUserInfo();
    await signOutUseCase.execute();
  };

  return {
    handleSignOut,
  };
};
